import React from "react"
import {
  actualiteInfos,
  actualiteCategorie,
  actualiteTitle,
  actualiteResume,
  actualiteDate,
} from "../styles/listActus.module.scss"
import {
  ActuTaxo,
  ActualiteTitle,
} from "./styled-components/actualite-item-styled"
import SummaryTransformer from "gatsby-theme-blank/src/components/Transformers/summary-transformer"
import { summaryLength } from "../../../constants"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import PropTypes from "prop-types"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

const ActualiteItem = ({ actu }) => (
  <>
    <EditButton link={"/node/" + actu.drupal_internal__nid + "/edit"} />
    {actu.relationships.field_image_actus?.localFile && (
      <TransitionFade arialabel={actu.title} link={actu.path.alias}>
        <NonStretchedImage
          {...actu.relationships.field_image_actus.localFile}
          ariaHidden={true}
        />
      </TransitionFade>
    )}
    <div className={actualiteInfos}>
      {actu.relationships.field_taxonomie_thematique?.length > 0 && (
        <ActuTaxo className={actualiteCategorie}>
          {actu.relationships.field_taxonomie_thematique[0].name}
        </ActuTaxo>
      )}
      <p className={actualiteDate}>
        posté le {actu.field_date_de_publication || actu.created}
      </p>
      <ActualiteTitle className={actualiteTitle}>
        <TransitionFade link={actu.path.alias}>{actu.title}</TransitionFade>
      </ActualiteTitle>
      {actu.body && (
        <div
          className={actualiteResume}
          dangerouslySetInnerHTML={{
            __html: SummaryTransformer(actu.body, summaryLength),
          }}
        />
      )}
    </div>
  </>
)

ActualiteItem.propTypes = {
  actu: PropTypes.object.isRequired,
  colors: PropTypes.object,
}

export default ActualiteItem
